import React, { useState } from "react";
import AuthCard from "../../shared/components/CustomCards";
import {
  CustomCheckbox,
  CustomInput,
  CustomPassword,
} from "../../shared/components/AllInputs";
import { Link, useNavigate } from "react-router-dom";
import PrimaryButton from "../../shared/components/CustomButtons";
import { useDispatch } from "react-redux";
import formValidation from "../../utils/validations";
import { showFormErrors } from "../../utils/commonFunctions";
import { loginAction } from "../../store/actions/auth.actions";

export default function Login() {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [loading, setLoading] = useState(false);
  const ignore = ["rememberMe"];

  const [data, setData] = useState({
    email: "",
    loginPassword: "",
    rememberMe: "",
  });

  const handleChange = ({ name, value }) => {
    const formErrors = formValidation(name, value, data, ignore);
    setData((prev) => ({ ...prev, [name]: value, formErrors }));
  };

  const login = () => {
    if (showFormErrors(data, setData, ignore)) {
      dispatch(loginAction(data, setLoading, navigate));
    }
  };

  return (
    <div className="flex justify-content-center align-items-center h-full">
      <AuthCard heading={"Login to account"}>
        <CustomInput
          label="Email"
          name="email"
          data={data}
          placeholder="Email"
          col={12}
          onChange={handleChange}
        />
        <CustomPassword
          name="loginPassword"
          label="Password"
          data={data}
          placeholder="Password"
          col={12}
          onChange={handleChange}
        />
        <div className="flex align-items-center justify-content-between my-3">
          <CustomCheckbox
            name="rememberMe"
            label="Remember Me"
            col={6}
            data={data}
            onChange={handleChange}
          />
          <Link
            to="/auth/forgot-password"
            className="no-underline text-sm heading"
          >
            Forgot Password?
          </Link>
        </div>
        <PrimaryButton label="Log in" loading={loading} onClick={login} />
        <p className="text-sm font-medium heading text-center mt-5">
          Don't have an account yet?{" "}
          <Link
            to={"/auth/register"}
            className="no-underline primary-color font-bold"
          >
            Sign up
          </Link>{" "}
        </p>
      </AuthCard>
    </div>
  );
}
